@if (showLdr) {
<ds-loading></ds-loading>
}

<!-- Header Section - Brand Style -->
<div
  class="relative mb-4 overflow-hidden cstmmrgin"
  style="background: white; border-bottom: 1px solid #e5e7eb"
>
  <!-- Top accent stripe: red + teal brand colors -->
  <div
    style="
      height: 3px;
      background: linear-gradient(
        90deg,
        #e53e3e 0%,
        #e53e3e 40%,
        #0f766e 40%,
        #0f766e 100%
      );
    "
  ></div>
  <div
    class="flex items-center justify-between px-5 py-3 flex-wrap gap-2 relative"
  >
    <!-- Decorative background elements -->
    <div
      class="absolute inset-0"
      style="pointer-events: none; overflow: hidden"
    >
      <!-- Dot grid pattern -->
      <div
        class="absolute inset-0"
        style="
          opacity: 0.15;
          background-image: radial-gradient(
            circle,
            #0f766e 1px,
            transparent 1px
          );
          background-size: 20px 20px;
        "
      ></div>
      <!-- Crosshatch pattern overlay -->
      <div
        class="absolute inset-0"
        style="
          opacity: 0.06;
          background-image: repeating-linear-gradient(
              45deg,
              transparent,
              transparent 10px,
              #0f766e 10px,
              #0f766e 11px
            ),
            repeating-linear-gradient(
              -45deg,
              transparent,
              transparent 10px,
              #0f766e 10px,
              #0f766e 11px
            );
        "
      ></div>
      <!-- Filled circles -->
      <div
        class="absolute"
        style="
          right: 115px;
          top: -8px;
          width: 65px;
          height: 65px;
          border-radius: 50%;
          background: rgba(15, 118, 110, 0.12);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 185px;
          bottom: -12px;
          width: 55px;
          height: 55px;
          border-radius: 50%;
          background: rgba(229, 62, 62, 0.1);
        "
      ></div>
      <!-- Dashed circles -->
      <div
        class="absolute"
        style="
          right: 75px;
          bottom: 0px;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          border: 2px dashed rgba(15, 118, 110, 0.25);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 160px;
          top: 5px;
          width: 28px;
          height: 28px;
          border-radius: 50%;
          border: 2px dashed rgba(229, 62, 62, 0.2);
        "
      ></div>
      <!-- Small solid dots -->
      <div
        class="absolute"
        style="
          right: 250px;
          top: 8px;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: rgba(15, 118, 110, 0.25);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 230px;
          bottom: 10px;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: rgba(229, 62, 62, 0.22);
        "
      ></div>
      <div
        class="absolute"
        style="
          right: 145px;
          bottom: 5px;
          width: 5px;
          height: 5px;
          border-radius: 50%;
          background: rgba(15, 118, 110, 0.2);
        "
      ></div>
    </div>
    <!-- Left: Icon + Title -->
    <div class="relative flex items-center gap-3">
      <!-- Icon -->
      <div
        class="flex-shrink-0 flex items-center justify-center"
        style="
          width: 42px;
          height: 42px;
          background: linear-gradient(135deg, #e53e3e, #dc2626);
          border-radius: 10px;
          box-shadow: 0 2px 6px rgba(229, 62, 62, 0.25);
        "
      >
        <svg
          style="width: 20px; height: 20px; color: #fff"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M13 10V3L4 14h7v7l9-11h-7z"
          ></path>
        </svg>
      </div>
      <div>
        @if (clntDtls && clntDtls.length > 0) {
        <h1
          class="font-bold mb-0"
          style="font-size: 17px; color: #134e4a; letter-spacing: 0.3px"
        >
          <app-common-header [header_name]="header_label"></app-common-header>
        </h1>
        }
        <div class="flex items-center gap-2">
          <div
            style="
              width: 14px;
              height: 2px;
              background: #e53e3e;
              border-radius: 1px;
            "
          ></div>
          <p
            class="mb-0"
            style="
              font-size: 11px;
              color: #64748b;
              font-weight: 500;
              letter-spacing: 0.3px;
            "
          >
            Fuel Consumption Analytics
          </p>
        </div>
      </div>
    </div>
    <!-- Right: Action buttons -->
    <div class="relative flex items-center flex-wrap" style="gap: 8px">
      @if (fromUrbanDashboard) {
      <button
        (click)="goBackToDashboard()"
        class="flex items-center gap-1.5 px-3 py-1.5 rounded-md transition-all text-xs font-semibold cursor-pointer"
        style="background: #f1f5f9; color: #475569; border: 1px solid #e2e8f0"
        onmouseenter="this.style.background='#e2e8f0'"
        onmouseleave="this.style.background='#f1f5f9'"
      >
        <svg
          style="width: 14px; height: 14px"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M11 17l-5-5m0 0l5-5m-5 5h12"
          ></path>
        </svg>
        Go Back
      </button>
      } @if (filters == true) {
      <button
        (click)="fltrs()"
        class="flex items-center gap-1.5 px-4 py-1.5 rounded-md transition-all text-xs font-semibold cursor-pointer"
        style="background: #0f766e; color: #ffffff; border: none"
        onmouseenter="this.style.background='#115e59'"
        onmouseleave="this.style.background='#0f766e'"
      >
        <span
          nz-icon
          nzType="filter"
          nzTheme="outline"
          style="font-size: 12px"
        ></span>
        <span>Hide Filters</span>
      </button>
      } @if (filters == false) {
      <button
        (click)="fltrs()"
        class="flex items-center gap-1.5 px-4 py-1.5 rounded-md transition-all text-xs font-semibold cursor-pointer"
        style="background: #0f766e; color: #ffffff; border: none"
        onmouseenter="this.style.background='#115e59'"
        onmouseleave="this.style.background='#0f766e'"
      >
        <span
          nz-icon
          nzType="filter"
          nzTheme="outline"
          style="font-size: 12px"
        ></span>
        <span>Show Filters</span>
      </button>
      }
    </div>
  </div>
</div>

<div class="mx-auto px-3">
  <!-- Filter Section -->
  @if (filters) {
  <div
    class="bg-white rounded-lg p-4 mb-4 fltrsctn"
    style="border: 1px solid #e5e7eb; box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04)"
  >
    <div class="flex items-center gap-3 flex-wrap">
      <div class="flex flex-col min-w-0 w-1/5">
        <label
          style="
            font-size: 13px;
            font-weight: 600;
            color: #64748b;
            margin-bottom: 6px;
            text-transform: uppercase;
            letter-spacing: 0.5px;
          "
          >Month</label
        >
        <nz-date-picker
          nzMode="month"
          [nzFormat]="'MMM yyyy'"
          [(ngModel)]="slctdDt"
          (ngModelChange)="onMonthChange($event)"
          class="filter-input w-full"
        >
        </nz-date-picker>
      </div>
      <div class="flex flex-col min-w-0 w-1/5">
        <label
          style="
            font-size: 13px;
            font-weight: 600;
            color: #64748b;
            margin-bottom: 6px;
            text-transform: uppercase;
            letter-spacing: 0.5px;
          "
          >ULB</label
        >
        <nz-select
          class="filter-input w-full"
          nzShowSearch
          nzPlaceHolder="All ULBs"
          [(ngModel)]="selectedtenant"
          (ngModelChange)="ontntSelect($event)"
          [ngModelOptions]="{ standalone: true }"
        >
          <nz-option [nzLabel]="'All ULBs'" [nzValue]="0"></nz-option>
          @for (t of tntLst; track t) {
          <nz-option
            [nzValue]="t.tnt_id"
            [nzLabel]="t.tnt_dsply_nm || t.tnt_nm"
          ></nz-option>
          }
        </nz-select>
      </div>
    </div>
  </div>
  }

  <!-- KPI Summary Cards -->
  @if (fuelSummary) {
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
    <!-- Overall Card - Teal -->
    <div
      class="rounded-lg overflow-hidden"
      style="
        background: #f0fdfa;
        border: 1px solid #99f6e4;
        box-shadow: 0 2px 8px rgba(15, 118, 110, 0.1);
      "
    >
      <div style="padding: 16px 20px">
        <div class="flex items-center justify-between mb-3">
          <span
            style="
              font-size: 13px;
              font-weight: 700;
              color: #0f766e;
              text-transform: uppercase;
              letter-spacing: 0.5px;
            "
            >Overall</span
          >
          <div
            class="flex items-center justify-center"
            style="
              width: 36px;
              height: 36px;
              background: #ccfbf1;
              border-radius: 10px;
              border: 1px solid #99f6e4;
            "
          >
            <svg
              style="width: 18px; height: 18px; color: #0f766e"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M13 10V3L4 14h7v7l9-11h-7z"
              ></path>
            </svg>
          </div>
        </div>
        <div class="flex items-center" style="gap: 0">
          <div class="text-center flex-1" style="padding: 8px 4px">
            <div
              style="
                font-size: 22px;
                font-weight: 700;
                color: #0f766e;
                line-height: 1.2;
              "
            >
              {{ fuelSummary.total_entries || 0 }}
            </div>
            <div
              style="
                font-size: 11px;
                font-weight: 600;
                color: #64748b;
                text-transform: uppercase;
                margin-top: 3px;
              "
            >
              Entries
            </div>
          </div>
          <div style="width: 1px; height: 40px; background: #99f6e4"></div>
          <div class="text-center flex-1" style="padding: 8px 4px">
            <div
              style="
                font-size: 22px;
                font-weight: 700;
                color: #0f766e;
                line-height: 1.2;
              "
            >
              {{ fuelSummary.total_lt || 0 | number : "1.0-0" }}
            </div>
            <div
              style="
                font-size: 11px;
                font-weight: 600;
                color: #64748b;
                text-transform: uppercase;
                margin-top: 3px;
              "
            >
              Total Lt
            </div>
          </div>
          <div style="width: 1px; height: 40px; background: #99f6e4"></div>
          <div class="text-center flex-1" style="padding: 8px 4px">
            <div
              style="
                font-size: 22px;
                font-weight: 700;
                color: #0f766e;
                line-height: 1.2;
              "
            >
              {{ fuelSummary.total_am || 0 | number : "1.0-0" }}
            </div>
            <div
              style="
                font-size: 11px;
                font-weight: 600;
                color: #64748b;
                text-transform: uppercase;
                margin-top: 3px;
              "
            >
              Amount
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Petrol Card - Rose -->
    <div
      class="rounded-lg overflow-hidden"
      style="
        background: #fff1f2;
        border: 1px solid #fecdd3;
        box-shadow: 0 2px 8px rgba(225, 29, 72, 0.08);
      "
    >
      <div style="padding: 16px 20px">
        <div class="flex items-center justify-between mb-3">
          <span
            style="
              font-size: 13px;
              font-weight: 700;
              color: #be123c;
              text-transform: uppercase;
              letter-spacing: 0.5px;
            "
            >Petrol</span
          >
          <div
            class="flex items-center justify-center"
            style="
              width: 36px;
              height: 36px;
              background: #ffe4e6;
              border-radius: 10px;
              border: 1px solid #fecdd3;
            "
          >
            <svg
              style="width: 18px; height: 18px; color: #e11d48"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z"
              ></path>
            </svg>
          </div>
        </div>
        <div class="flex items-center" style="gap: 0">
          <div class="text-center flex-1" style="padding: 8px 4px">
            <div
              style="
                font-size: 22px;
                font-weight: 700;
                color: #be123c;
                line-height: 1.2;
              "
            >
              {{ fuelSummary.ptrl_ct || 0 }}
            </div>
            <div
              style="
                font-size: 11px;
                font-weight: 600;
                color: #64748b;
                text-transform: uppercase;
                margin-top: 3px;
              "
            >
              Count
            </div>
          </div>
          <div style="width: 1px; height: 40px; background: #fecdd3"></div>
          <div class="text-center flex-1" style="padding: 8px 4px">
            <div
              style="
                font-size: 22px;
                font-weight: 700;
                color: #be123c;
                line-height: 1.2;
              "
            >
              {{ fuelSummary.ptrl_lt || 0 | number : "1.0-0" }}
            </div>
            <div
              style="
                font-size: 11px;
                font-weight: 600;
                color: #64748b;
                text-transform: uppercase;
                margin-top: 3px;
              "
            >
              Litres
            </div>
          </div>
          <div style="width: 1px; height: 40px; background: #fecdd3"></div>
          <div class="text-center flex-1" style="padding: 8px 4px">
            <div
              style="
                font-size: 22px;
                font-weight: 700;
                color: #be123c;
                line-height: 1.2;
              "
            >
              {{ fuelSummary.ptrl_am || 0 | number : "1.0-0" }}
            </div>
            <div
              style="
                font-size: 11px;
                font-weight: 600;
                color: #64748b;
                text-transform: uppercase;
                margin-top: 3px;
              "
            >
              Amount
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Diesel Card - Emerald -->
    <div
      class="rounded-lg overflow-hidden"
      style="
        background: #ecfdf5;
        border: 1px solid #a7f3d0;
        box-shadow: 0 2px 8px rgba(5, 150, 105, 0.08);
      "
    >
      <div style="padding: 16px 20px">
        <div class="flex items-center justify-between mb-3">
          <span
            style="
              font-size: 13px;
              font-weight: 700;
              color: #047857;
              text-transform: uppercase;
              letter-spacing: 0.5px;
            "
            >Diesel</span
          >
          <div
            class="flex items-center justify-center"
            style="
              width: 36px;
              height: 36px;
              background: #d1fae5;
              border-radius: 10px;
              border: 1px solid #a7f3d0;
            "
          >
            <svg
              style="width: 18px; height: 18px; color: #059669"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z"
              ></path>
            </svg>
          </div>
        </div>
        <div class="flex items-center" style="gap: 0">
          <div class="text-center flex-1" style="padding: 8px 4px">
            <div
              style="
                font-size: 22px;
                font-weight: 700;
                color: #047857;
                line-height: 1.2;
              "
            >
              {{ fuelSummary.dsl_ct || 0 }}
            </div>
            <div
              style="
                font-size: 11px;
                font-weight: 600;
                color: #64748b;
                text-transform: uppercase;
                margin-top: 3px;
              "
            >
              Count
            </div>
          </div>
          <div style="width: 1px; height: 40px; background: #a7f3d0"></div>
          <div class="text-center flex-1" style="padding: 8px 4px">
            <div
              style="
                font-size: 22px;
                font-weight: 700;
                color: #047857;
                line-height: 1.2;
              "
            >
              {{ fuelSummary.dsl_lt || 0 | number : "1.0-0" }}
            </div>
            <div
              style="
                font-size: 11px;
                font-weight: 600;
                color: #64748b;
                text-transform: uppercase;
                margin-top: 3px;
              "
            >
              Litres
            </div>
          </div>
          <div style="width: 1px; height: 40px; background: #a7f3d0"></div>
          <div class="text-center flex-1" style="padding: 8px 4px">
            <div
              style="
                font-size: 22px;
                font-weight: 700;
                color: #047857;
                line-height: 1.2;
              "
            >
              {{ fuelSummary.dsl_am || 0 | number : "1.0-0" }}
            </div>
            <div
              style="
                font-size: 11px;
                font-weight: 600;
                color: #64748b;
                text-transform: uppercase;
                margin-top: 3px;
              "
            >
              Amount
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- CNG Card - Blue -->
    <div
      class="rounded-lg overflow-hidden"
      style="
        background: #eff6ff;
        border: 1px solid #bfdbfe;
        box-shadow: 0 2px 8px rgba(37, 99, 235, 0.08);
      "
    >
      <div style="padding: 16px 20px">
        <div class="flex items-center justify-between mb-3">
          <span
            style="
              font-size: 13px;
              font-weight: 700;
              color: #1d4ed8;
              text-transform: uppercase;
              letter-spacing: 0.5px;
            "
            >CNG</span
          >
          <div
            class="flex items-center justify-center"
            style="
              width: 36px;
              height: 36px;
              background: #dbeafe;
              border-radius: 10px;
              border: 1px solid #bfdbfe;
            "
          >
            <svg
              style="width: 18px; height: 18px; color: #2563eb"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z"
              ></path>
            </svg>
          </div>
        </div>
        <div class="flex items-center" style="gap: 0">
          <div class="text-center flex-1" style="padding: 8px 4px">
            <div
              style="
                font-size: 22px;
                font-weight: 700;
                color: #1d4ed8;
                line-height: 1.2;
              "
            >
              {{ fuelSummary.cng_ct || 0 }}
            </div>
            <div
              style="
                font-size: 11px;
                font-weight: 600;
                color: #64748b;
                text-transform: uppercase;
                margin-top: 3px;
              "
            >
              Count
            </div>
          </div>
          <div style="width: 1px; height: 40px; background: #bfdbfe"></div>
          <div class="text-center flex-1" style="padding: 8px 4px">
            <div
              style="
                font-size: 22px;
                font-weight: 700;
                color: #1d4ed8;
                line-height: 1.2;
              "
            >
              {{ fuelSummary.cng_lt || 0 | number : "1.0-0" }}
            </div>
            <div
              style="
                font-size: 11px;
                font-weight: 600;
                color: #64748b;
                text-transform: uppercase;
                margin-top: 3px;
              "
            >
              KG
            </div>
          </div>
          <div style="width: 1px; height: 40px; background: #bfdbfe"></div>
          <div class="text-center flex-1" style="padding: 8px 4px">
            <div
              style="
                font-size: 22px;
                font-weight: 700;
                color: #1d4ed8;
                line-height: 1.2;
              "
            >
              {{ fuelSummary.cng_am || 0 | number : "1.0-0" }}
            </div>
            <div
              style="
                font-size: 11px;
                font-weight: 600;
                color: #64748b;
                text-transform: uppercase;
                margin-top: 3px;
              "
            >
              Amount
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  }

  <!-- ULBs & Vehicles Section - Clean Container -->
  @if (fuelSummary) {
  <div
    class="bg-white rounded-lg mb-4 overflow-hidden"
    style="border: 1px solid #e5e7eb; box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05)"
  >
    <div
      class="flex items-center gap-2 px-4 py-2.5"
      style="border-bottom: 1px solid #f1f5f9"
    >
      <div
        class="flex items-center justify-center"
        style="
          width: 28px;
          height: 28px;
          background: #f1f5f9;
          border-radius: 6px;
        "
      >
        <svg
          style="width: 14px; height: 14px; color: #475569"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
          ></path>
        </svg>
      </div>
      <span
        style="
          font-size: 14px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.3px;
        "
        >ULBs & Vehicles</span
      >
      <span
        style="
          font-size: 13px;
          font-weight: 500;
          color: #94a3b8;
          margin-left: 8px;
          font-style: italic;
          text-transform: none;
        "
        >( Click on counts to filter grid below )</span
      >
    </div>
    <div class="grid grid-cols-5 gap-0" style="padding: 0">
      <div
        class="clickable text-center"
        style="
          padding: 14px 12px;
          border-right: 1px solid #f1f5f9;
          transition: background 0.15s;
        "
        [class.card-active]="selectedUlbCard === 'ulb_total'"
        (click)="onUlbCardClick('ulb_total')"
        onmouseenter="this.style.background='#f8fafc'"
        onmouseleave="this.style.background='transparent'"
      >
        <div
          style="
            font-size: 24px;
            font-weight: 700;
            color: #1e293b;
            line-height: 1.2;
          "
        >
          {{ totalUlbs }}
        </div>
        <div
          style="
            font-size: 12px;
            font-weight: 600;
            color: #94a3b8;
            text-transform: uppercase;
            margin-top: 4px;
          "
        >
          Total ULBs
        </div>
      </div>
      <div
        class="clickable text-center"
        style="
          padding: 14px 12px;
          border-right: 1px solid #f1f5f9;
          transition: background 0.15s;
        "
        [class.card-active]="selectedUlbCard === 'ulb_entered'"
        (click)="onUlbCardClick('ulb_entered')"
        onmouseenter="this.style.background='#f8fafc'"
        onmouseleave="this.style.background='transparent'"
      >
        <div
          style="
            font-size: 24px;
            font-weight: 700;
            color: #059669;
            line-height: 1.2;
          "
        >
          {{ ulbsFuelEntered }}
        </div>
        <div
          style="
            font-size: 12px;
            font-weight: 600;
            color: #94a3b8;
            text-transform: uppercase;
            margin-top: 4px;
          "
        >
          Fuel Entered
        </div>
      </div>
      <div
        class="clickable text-center"
        style="
          padding: 14px 12px;
          border-right: 1px solid #f1f5f9;
          transition: background 0.15s;
        "
        [class.card-active]="selectedUlbCard === 'ulb_not_entered'"
        (click)="onUlbCardClick('ulb_not_entered')"
        onmouseenter="this.style.background='#f8fafc'"
        onmouseleave="this.style.background='transparent'"
      >
        <div
          style="
            font-size: 24px;
            font-weight: 700;
            color: #dc2626;
            line-height: 1.2;
          "
        >
          {{ ulbsFuelNotEntered }}
        </div>
        <div
          style="
            font-size: 12px;
            font-weight: 600;
            color: #94a3b8;
            text-transform: uppercase;
            margin-top: 4px;
          "
        >
          Not Entered
        </div>
      </div>
      <div
        class="text-center"
        style="padding: 14px 12px; border-right: 1px solid #f1f5f9"
      >
        <div
          style="
            font-size: 24px;
            font-weight: 700;
            color: #1e293b;
            line-height: 1.2;
          "
        >
          {{ fuelSummary.vehicles_ct || 0 }}
        </div>
        <div
          style="
            font-size: 12px;
            font-weight: 600;
            color: #94a3b8;
            text-transform: uppercase;
            margin-top: 4px;
          "
        >
          Vehicles
        </div>
      </div>
      <div class="text-center" style="padding: 14px 12px">
        <div
          style="
            font-size: 24px;
            font-weight: 700;
            color: #d97706;
            line-height: 1.2;
          "
        >
          {{ mileageVarianceCount }}
        </div>
        <div
          style="
            font-size: 12px;
            font-weight: 600;
            color: #94a3b8;
            text-transform: uppercase;
            margin-top: 4px;
          "
        >
          Mileage Variance
        </div>
      </div>
    </div>
  </div>
  }

  <!-- Charts Section - 3 Clean Cards -->
  <div class="fl-charts-grid mb-4">
    <!-- Daily Fuel Trend -->
    <div class="fl-chart-card">
      <div class="fl-chart-header">
        <div class="flex items-center gap-2">
          <svg
            style="width: 16px; height: 16px; color: #475569"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
            ></path>
          </svg>
          <h3>Daily Fuel Trend</h3>
        </div>
        <span class="fl-chart-badge">Monthly</span>
      </div>
      <div class="fl-chart-body" id="last7DaysChartDiv"></div>
    </div>

    <!-- Fuel Type Distribution -->
    <div class="fl-chart-card">
      <div class="fl-chart-header">
        <div class="flex items-center gap-2">
          <svg
            style="width: 16px; height: 16px; color: #475569"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z"
            ></path>
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z"
            ></path>
          </svg>
          <h3>Fuel Type Distribution</h3>
        </div>
        <span class="fl-chart-badge">Donut</span>
      </div>
      <div class="fl-chart-body" id="fuelTypePieChartDiv"></div>
    </div>

    <!-- Monthly Comparison -->
    <div class="fl-chart-card">
      <div class="fl-chart-header">
        <div class="flex items-center gap-2">
          <svg
            style="width: 16px; height: 16px; color: #475569"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
            ></path>
          </svg>
          <h3>Monthly Comparison</h3>
        </div>
        <span class="fl-chart-badge">vs Prev</span>
      </div>
      <div class="fl-chart-body" id="monthlyCompChartDiv"></div>
    </div>
  </div>

  <!-- Tabbed Grid Section -->
  <div
    class="fl-grid-card fl-grid-section"
    style="margin-bottom: 24px"
    id="ulbFuelGrid"
  >
    <!-- Tab Headers -->
    <div class="flex" style="border-bottom: 1px solid #e5e7eb">
      <button
        (click)="activeTabIndex = 0"
        class="px-5 py-2.5 text-sm font-semibold transition-colors duration-200 cursor-pointer bg-transparent"
        style="border: none; border-bottom: 2px solid transparent"
        [style.borderBottomColor]="
          activeTabIndex === 0 ? '#0f766e' : 'transparent'
        "
        [style.color]="activeTabIndex === 0 ? '#0f766e' : '#6b7280'"
      >
        ULB Wise Fuel Data
      </button>
      <button
        (click)="drilldownUlbName ? (activeTabIndex = 1) : null"
        class="px-5 py-2.5 text-sm font-semibold transition-colors duration-200 bg-transparent flex items-center gap-1.5"
        style="border: none; border-bottom: 2px solid transparent"
        [style.borderBottomColor]="
          activeTabIndex === 1 && drilldownUlbName ? '#0f766e' : 'transparent'
        "
        [style.color]="
          activeTabIndex === 1 && drilldownUlbName
            ? '#0f766e'
            : drilldownUlbName
            ? '#6b7280'
            : '#d1d5db'
        "
        [style.cursor]="drilldownUlbName ? 'pointer' : 'not-allowed'"
      >
        <span>{{
          drilldownUlbName ? drilldownUlbName + " - Vehicles" : "Vehicle Wise"
        }}</span>
        @if (drilldownUlbName) {
        <button
          (click)="goBackToAllUlbs(); $event.stopPropagation()"
          class="ml-2 flex items-center gap-1 px-2 py-0.5 text-white rounded text-xs font-medium cursor-pointer"
          style="background: #475569; border: none"
          onmouseenter="this.style.background='#334155'"
          onmouseleave="this.style.background='#475569'"
        >
          <svg
            style="width: 12px; height: 12px"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M11 17l-5-5m0 0l5-5m-5 5h12"
            ></path>
          </svg>
          All ULBs
        </button>
        }
      </button>
    </div>

    <!-- Tab 1: ULB Wise Fuel Data -->
    @if (activeTabIndex === 0) {
    <div class="pt-3">
      <app-data-grid
        [totalItems]="gridTotals0"
        style="width: 100%; max-width: 100% !important"
        [dataSource]="ulbWiseData"
        [searchPanel]="true"
        [filterRow]="true"
        [filterPanel]="false"
        [groupPanel]="false"
        [columnChooser]="false"
        [allowExport]="true"
        exportFileName="ULB Wise Fuel Data"
        [pageSize]="10"
        [allowedPageSizes]="[10, 20, 50, 100]"
        [showPageSizeSelector]="true"
        [rowAlternationEnabled]="true"
        [showBorders]="true"
        [wordWrapEnabled]="true"
      >
        <app-grid-column
          dataField="sno"
          caption="S.No"
          [minWidth]="55"
          [width]="60"
          alignment="center"
          [sortOrder]="'asc'"
          [sortIndex]="0"
        ></app-grid-column>
        <app-grid-column
          dataField="tnt_dsply_nm"
          caption="ULB Name"
          [minWidth]="150"
          cellTemplate="ulbLinkTemplate"
        ></app-grid-column>
        <app-grid-column
          dataField="total_entries"
          caption="Entries"
          [minWidth]="75"
          alignment="center"
        ></app-grid-column>
        <app-grid-column
          dataField="ptrl_lt"
          caption="Petrol (Lt)"
          [minWidth]="95"
          alignment="center"
          [format]="{ type: 'fixedPoint', precision: 2 }"
        ></app-grid-column>
        <app-grid-column
          dataField="dsl_lt"
          caption="Diesel (Lt)"
          [minWidth]="95"
          alignment="center"
          [format]="{ type: 'fixedPoint', precision: 2 }"
        ></app-grid-column>
        <app-grid-column
          dataField="cng_lt"
          caption="CNG (Kg)"
          [minWidth]="85"
          alignment="center"
          [format]="{ type: 'fixedPoint', precision: 2 }"
        ></app-grid-column>
        <app-grid-column
          dataField="total_lt"
          caption="Total (Lt)"
          [minWidth]="90"
          alignment="center"
          [format]="{ type: 'fixedPoint', precision: 2 }"
        ></app-grid-column>
        <app-grid-column
          dataField="total_am"
          caption="Amount"
          [minWidth]="95"
          alignment="center"
          [format]="{ type: 'fixedPoint', precision: 2 }"
        ></app-grid-column>
        <app-grid-column
          dataField="vehicles_ct"
          caption="Vehicles"
          [minWidth]="75"
          alignment="center"
        ></app-grid-column>
        <ng-template appGridCell="ulbLinkTemplate" let-data="cell"
          ><div>
            <a
              class="ulb-link"
              (click)="onUlbNameClick(data.data); $event.stopPropagation()"
              >{{ data.value || data.data.tnt_nm }}</a
            >
          </div></ng-template
        >
      </app-data-grid>
      @if (!ulbWiseData || ulbWiseData.length == 0) {
      <div class="empty-state">
        <i nz-icon nzType="inbox" nzTheme="outline"></i>
        <p>No ULB-wise fuel data available</p>
      </div>
      }
    </div>
    }

    <!-- Tab 2: Vehicle Wise Fuel Data -->
    @if (activeTabIndex === 1) {
    <div class="pt-3">
      @if (selectedUlbData) {
      <div>
        @if (vehicleDrillLdr) {
        <div class="text-center py-8">
          <nz-spin nzSimple></nz-spin>
        </div>
        } @if (!vehicleDrillLdr) {
        <div>
          <app-data-grid
            style="width: 100%; max-width: 100% !important"
            [dataSource]="vehicleDrillData"
            [searchPanel]="true"
            [filterRow]="true"
            [filterPanel]="false"
            [groupPanel]="false"
            [columnChooser]="false"
            [allowExport]="true"
            exportFileName="Vehicle Wise Fuel Details"
            [pageSize]="10"
            [allowedPageSizes]="[10, 20, 50]"
            [showPageSizeSelector]="true"
            [rowAlternationEnabled]="true"
            [showBorders]="true"
            [wordWrapEnabled]="true"
          >
            <app-grid-column
              dataField="sno"
              caption="S.No"
              [minWidth]="55"
              [width]="60"
              alignment="center"
              [sortOrder]="'asc'"
              [sortIndex]="0"
            ></app-grid-column>
            <app-grid-column
              dataField="vehicle_no"
              caption="Vehicle No"
              [minWidth]="120"
            ></app-grid-column>
            <app-grid-column
              dataField="fuel_type"
              caption="Fuel Type"
              [minWidth]="90"
              alignment="center"
              cellTemplate="fuelTypeTemplate"
            ></app-grid-column>
            <app-grid-column
              dataField="litres"
              caption="Litres"
              [minWidth]="85"
              alignment="center"
              [format]="{ type: 'fixedPoint', precision: 2 }"
            ></app-grid-column>
            <app-grid-column
              dataField="amount"
              caption="Amount"
              [minWidth]="90"
              alignment="center"
              [format]="{ type: 'fixedPoint', precision: 2 }"
            ></app-grid-column>
            <app-grid-column
              dataField="entries"
              caption="Entries"
              [minWidth]="70"
              alignment="center"
            ></app-grid-column>
            <app-grid-column
              dataField="last_fueled"
              caption="Last Fueled"
              [minWidth]="100"
              alignment="center"
            ></app-grid-column>
            <ng-template appGridCell="fuelTypeTemplate" let-data="cell"
              ><div>
                <span
                  class="fuel-badge"
                  [ngClass]="{
                    'fuel-petrol': data.value === 'Petrol',
                    'fuel-diesel': data.value === 'Diesel',
                    'fuel-cng': data.value === 'CNG'
                  }"
                  >{{ data.value }}</span
                >
              </div></ng-template
            >
          </app-data-grid>
          @if (!vehicleDrillData || vehicleDrillData.length == 0) {
          <div class="empty-state">
            <i nz-icon nzType="inbox" nzTheme="outline"></i>
            <p>No vehicle fuel data found</p>
          </div>
          }
        </div>
        }
      </div>
      } @if (!selectedUlbData) {
      <div class="empty-state">
        <i nz-icon nzType="inbox" nzTheme="outline"></i>
        <p>Click on a ULB name to view vehicle-wise fuel details</p>
      </div>
      }
    </div>
    }
  </div>
</div>
